"use client";
import { jsx as l } from "react/jsx-runtime";
import { memo as a } from "react";
import t from "../components/Icon/SvgIcon.js";
const e = (o) => /* @__PURE__ */ l(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.024 21c-.048 0-.134-.012-.26-.136l-5.207-6.911-.053-.089A6.84 6.84 0 0 1 5.25 9.968c.018-3.705 3.057-6.718 6.774-6.718 3.724 0 6.755 3.012 6.755 6.716 0 1.381-.415 2.711-1.23 3.898l-5.266 6.999c-.076.083-.177.137-.259.137m-6.452-6.283 5.249 6.965c.3.361.739.568 1.203.568.439 0 .872-.2 1.173-.533l5.203-6.934.005-.005c.073-.074.163-.165.2-.254a7.97 7.97 0 0 0 1.424-4.558C20.029 5.573 16.438 2 12.024 2 7.62 2 4.022 5.572 4 9.973a8.1 8.1 0 0 0 1.457 4.575.6.6 0 0 0 .115.169m8.085-2.282-1.352-.71a.63.63 0 0 0-.582 0l-1.351.71.258-1.504a.63.63 0 0 0-.179-.552L9.357 9.312l1.511-.22a.62.62 0 0 0 .471-.341l.675-1.369.676 1.369a.62.62 0 0 0 .47.341l1.511.22-1.094 1.067a.63.63 0 0 0-.179.552zm-4.731 1.037a.627.627 0 0 0 .907.66l2.181-1.147 2.182 1.147c.211.11.465.091.658-.048a.63.63 0 0 0 .249-.612l-.417-2.428 1.765-1.721a.625.625 0 0 0-.347-1.065l-2.439-.355-1.09-2.21c-.211-.428-.911-.428-1.122 0l-1.089 2.21-2.44.355a.625.625 0 0 0-.347 1.065l1.765 1.721z",
        clipRule: "evenodd"
      }
    )
  }
), m = a(e);
export {
  m as LocationFavorite,
  m as default
};
